import { render, staticRenderFns } from "./invite_collaborators_modal.vue?vue&type=template&id=261226a1&scoped=true&"
import script from "./invite_collaborators_modal.vue?vue&type=script&lang=js&"
export * from "./invite_collaborators_modal.vue?vue&type=script&lang=js&"
import style0 from "./invite_collaborators_modal.vue?vue&type=style&index=0&id=261226a1&prod&lang=scss&"
import style1 from "./invite_collaborators_modal.vue?vue&type=style&index=1&id=261226a1&prod&lang=scss&scoped=true&"
import style2 from "./invite_collaborators_modal.vue?vue&type=style&index=2&id=261226a1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261226a1",
  null
  
)

export default component.exports